/**
 * Long-form Gemini Live “compliance monitoring” copy in product UI (env var names, GEMINI_LIVE_COMPLIANCE.md).
 *
 * - Default: off in development (`npm start`), on in production builds for review.
 * - REACT_APP_CHARTMIND_GEMINI_LIVE_COMPLIANCE_UI=false — hide in all builds.
 * - REACT_APP_CHARTMIND_GEMINI_LIVE_COMPLIANCE_UI=true — show in all builds (e.g. preview prod copy locally).
 */
export function isGeminiLiveComplianceMonitoringUiEnabled() {
  if (typeof process === 'undefined') return false;
  const v = process.env.REACT_APP_CHARTMIND_GEMINI_LIVE_COMPLIANCE_UI;
  if (v === 'false') return false;
  if (v === 'true') return true;
  return process.env.NODE_ENV === 'production';
}
